import React, { useState, useEffect } from "react";
import SideNav from "../Dashboard/SideNav";
import Navbar from "../Dashboard/Navbar";
import axios from "axios";
import "../Dashboard/styles.css";
import SearchBar from "../SearchBar/SearchBar";
import { Modal } from "react-bootstrap";

export default function Packageactive() {
  const [packages, setPackages] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [updatedPackage, setUpdatedPackage] = useState({
    title: "",
    price: "",
    duration: "",
    people: "",
    location: "",
    description: "",
    reviews: "",
    rating: "",
    image: "",
    province: "",
  });
  const [updatedImageFile, setUpdatedImageFile] = useState(null);
  const provinces = ["Punjab", "Sindh", "Balochistan", "KPK", "Gilgit-Baltistan", "Azad-Kashmir"];

  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    try {
      const response = await axios.get("https://journey-scape-main.vercel.app/api/auth/packages");
      setPackages(response.data);
    } catch (error) {
      console.error("Error while fetching packages:", error);
    }
  };

  const handleSearch = async (searchQuery) => {
    try {
      const response = await axios.get("https://journey-scape-main.vercel.app/api/auth/packages");
      const fetchedPackages = response.data;

      const filtered = fetchedPackages.filter(pkg =>
        pkg.title.toLowerCase().includes(searchQuery.toLowerCase())
      );
      
      setPackages(filtered);
    } catch (error) {
      console.error("Error while fetching and filtering packages:", error);
    }
  };

  const openUpdateModal = (pkg) => {
    setSelectedPackage(pkg);
    setUpdatedPackage({
      title: pkg.title,
      price: pkg.price,
      duration: pkg.duration,
      people: pkg.people,
      location: pkg.location,
      description: pkg.description,
      reviews: pkg.reviews,
      rating: pkg.rating,
      image: pkg.image,
      province: pkg.province,
    });
    setUpdatedImageFile(pkg.image); // Reset the image file
    setModalOpen(true);
  };

  const updatePackage = async () => {
    try {
      const formDataWithImage = new FormData();
      formDataWithImage.append("title", updatedPackage.title);
      formDataWithImage.append("price", updatedPackage.price);
      formDataWithImage.append("duration", updatedPackage.duration);
      formDataWithImage.append("people", updatedPackage.people);
      formDataWithImage.append("location", updatedPackage.location);
      formDataWithImage.append("description", updatedPackage.description);
      formDataWithImage.append("reviews", updatedPackage.reviews);
      formDataWithImage.append("rating", updatedPackage.rating);
      formDataWithImage.append("province", updatedPackage.province);
      if (updatedImageFile) {
        formDataWithImage.append("image", updatedImageFile);
      } else {
        formDataWithImage.append("image", updatedPackage.image); // Append the existing image if no new image selected
      }
  
      const response = await axios.put(
        `https://journey-scape-main.vercel.app/api/auth/packages/${selectedPackage._id}`,
        formDataWithImage,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("Package updated successfully:", response.data);
      fetchPackages(); // Refresh the package list after updating
      closeUpdateModal();
    } catch (error) {
      console.error("Error updating package:", error);
    }
  };
  const closeUpdateModal = () => {
    setModalOpen(false);
    setSelectedPackage(null);
    setUpdatedPackage({
      title: "",
      price: "",
      duration: "",
      people: "",
      location: "",
      description: "",
      reviews: "",
      rating: "",
      image: "",
      province: "",
    });
    setUpdatedImageFile(null); // Reset the image file
  };

  const deletePackage = async (packageId) => {
    // Implement the delete package functionality here
    try {
      const response = await axios.delete(`https://journey-scape-main.vercel.app/api/auth/packages/${packageId}`);
      console.log("Package deleted successfully:", response.data);
      fetchPackages(); // Refresh the package list after deleting
    } catch (error) {
      console.error("Error deleting package:", error);
    }
  };

  return (
    <>
      <Navbar />
      <SideNav />
      <div className="db-info-wrap db-package-wrap">
        <h2>Package List</h2>
        <div className="table-responsive">
        <SearchBar onSearch={handleSearch} />
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Name</th>
                <th>Days</th>
                <th>Destination</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {packages.map(pkg => (
                <tr key={pkg._id}>
                  <td>
                    <span className="package-name">{pkg.title}</span>
                  </td>
                  <td>{pkg.duration}</td>
                  <td>{pkg.location}</td>
                  <td>
                  <span className="badge bg-success" style={{ fontSize: '0.8rem' }}>Active</span>
                  </td>
                  <td>
              <div className="btn-group">
                <span className="badge bg-success" style={{ fontSize: '1rem', marginRight: '0.5rem' }}>
                  <i className="far fa-edit" onClick={() => openUpdateModal(pkg)} />
                </span>
                <span className="badge bg-danger" style={{ fontSize: '1rem' }} onClick={() => deletePackage(pkg._id)}>
                  <i className="far fa-trash-alt" />
                </span>
              </div>
            </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

<Modal className="popup" show={modalOpen} onHide={closeUpdateModal} centered>
  <Modal.Header closeButton>
    <Modal.Title>Update Package</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <form>
      <div className="form-group">
        <label htmlFor="title">Title</label>
        <input
          type="text"
          className="form-control"
          id="title"
          value={updatedPackage.title}
          onChange={(e) => setUpdatedPackage({ ...updatedPackage, title: e.target.value })}
        />
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="price">Price</label>
            <input
              type="text"
              className="form-control"
              id="price"
              value={updatedPackage.price}
              onChange={(e) => setUpdatedPackage({ ...updatedPackage, price: e.target.value })}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="duration">Duration</label>
            <input
              type="text"
              className="form-control"
              id="duration"
              value={updatedPackage.duration}
              onChange={(e) => setUpdatedPackage({ ...updatedPackage, duration: e.target.value })}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="people">People</label>
            <input
              type="text"
              className="form-control"
              id="people"
              value={updatedPackage.people}
              onChange={(e) => setUpdatedPackage({ ...updatedPackage, people: e.target.value })}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="location">Location</label>
            <input
              type="text"
              className="form-control"
              id="location"
              value={updatedPackage.location}
              onChange={(e) => setUpdatedPackage({ ...updatedPackage, location: e.target.value })}
            />
          </div>
        </div>
      </div>
      <div className="form-group">
  <label htmlFor="image">Image</label>
  <input
    type="file"
    accept="image/*"
    className="form-control-file"
    id="image"
    onChange={(e) => {
      setUpdatedImageFile(e.target.files[0]);
      setUpdatedPackage({
        ...updatedPackage,
        image: e.target.files[0] ? e.target.files[0].name : updatedPackage.image,
      });
    }}
  />
  {updatedPackage.image && (
    <p>Existing Image: {updatedPackage.image}</p>
  )}
  {updatedImageFile && (
    <p>Selected Image: {updatedImageFile.name}</p>
  )}
</div>


      <div className="form-group">
        <label htmlFor="description">Description</label>
        <textarea
          className="form-control"
          id="description"
          value={updatedPackage.description}
          onChange={(e) => setUpdatedPackage({ ...updatedPackage, description: e.target.value })}
        />
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="reviews">Reviews</label>
            <input
              type="number"
              className="form-control"
              id="reviews"
              value={updatedPackage.reviews}
              onChange={(e) => setUpdatedPackage({ ...updatedPackage, reviews: e.target.value })}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="rating">Rating</label>
            <input
              type="number"
              className="form-control"
              id="rating"
              value={updatedPackage.rating}
              onChange={(e) => setUpdatedPackage({ ...updatedPackage, rating: e.target.value })}
            />
          </div>
        </div>
      </div>
      <div className="form-group">
        <label htmlFor="province">Province</label>
        <select
          className="form-control"
          id="province"
          value={updatedPackage.province}
          onChange={(e) => setUpdatedPackage({ ...updatedPackage, province: e.target.value })}
        >
          <option value="">Select Province</option>
          {provinces.map((province) => (
            <option key={province} value={province}>
              {province}
            </option>
          ))}
        </select>
      </div>
      <button type="button" className="btn btn-primary" onClick={updatePackage}>
        Update
      </button>
    </form>
  </Modal.Body>
</Modal>

      {/* Content / End */}
    </>
  );
}
